import React from 'react'
import { CustomCalenderInput, CustomInput } from '../../../components/Input/input'
import { InputSwitch } from 'primereact/inputswitch'

export default function OwnerOperator({ownerOperatorData, setOwnerOperatorData}) {
  
    const handleChange = ({ name, value }) => {
        setOwnerOperatorData((prev) => ({ ...prev, [name]: value }));
      };
    return (
    <div>
          <p>Truck Information -</p>
          <div className="flex flex-wrap">
            <CustomInput
              name="truck_year"
              label="Year"
              value={ownerOperatorData?.truck_year}
              onChange={handleChange}
            />
            <CustomInput
              name="truck_make"
              label="Make"
              value={ownerOperatorData?.truck_make}
              onChange={handleChange}
            />
            <CustomCalenderInput
              name="last_annual_inspection"
              label="Last Annual Inspection"
              value={ownerOperatorData?.last_annual_inspection}
              onChange={handleChange}
            />
          </div>
          <div>
            <p>
              Do you have a WSIB exempt?
              <span className="inline-flex align-items-center gap-3 ml-4">
                <span
                  className={ownerOperatorData?.wsib_number === null ? "font-semibold" : ""}
                >
                  No
                </span>
                <InputSwitch
                  checked={ownerOperatorData?.wsib_number !== null}
                  onChange={(e) =>
                    setOwnerOperatorData((prev) => ({
                      ...prev,
                      wsib_number: e?.value ? "" : null,
                    }))
                  }
                />
                <span
                  className={ownerOperatorData?.wsib_number !== null ? "font-semibold" : ""}
                >
                  Yes
                </span>
              </span>
            </p>
            {ownerOperatorData?.wsib_number !== null && (
              <CustomInput
                label="WSIB#"
                name="wsib_number"
                value={ownerOperatorData?.wsib_number}
                onChange={handleChange}
              />
            )}
          </div>
          <div>
            <p>
              Do you have alternative insurance coverage including out of
              country?
              <span className="inline-flex align-items-center gap-3 ml-4">
                <span
                  className={
                    ownerOperatorData?.alternative_insurance === null ? "font-semibold" : ""
                  }
                >
                  No
                </span>
                <InputSwitch
                  checked={ownerOperatorData?.alternative_insurance !== null}
                  onChange={(e) =>
                    setOwnerOperatorData((prev) => ({
                      ...prev,
                      alternative_insurance: e?.value ? "" : null,
                    }))
                  }
                />
                <span
                  className={
                    ownerOperatorData?.alternative_insurance !== null ? "font-semibold" : ""
                  }
                >
                  Yes
                </span>
              </span>
            </p>
            {ownerOperatorData?.alternative_insurance !== null && (
              <CustomInput
                label="Name"
                name="alternative_insurance"
                value={ownerOperatorData?.alternative_insurance}
                onChange={handleChange}
              />
            )}
          </div>
          <div>
            <p>
              Have you ever been denied a license, permit or privilege to
              operate a motor vehicle?
              <span className="inline-flex align-items-center gap-3 ml-4">
                <span
                  className={
                    !ownerOperatorData?.denied_to_operate_vehicle ? "font-semibold" : ""
                  }
                >
                  No
                </span>
                <InputSwitch
                  checked={ownerOperatorData?.denied_to_operate_vehicle}
                  onChange={(e) =>
                    setOwnerOperatorData((prev) => ({
                      ...prev,
                      denied_to_operate_vehicle:
                        !prev.denied_to_operate_vehicle,
                    }))
                  }
                />
                <span
                  className={
                    ownerOperatorData?.denied_to_operate_vehicle ? "font-semibold" : ""
                  }
                >
                  Yes
                </span>
              </span>
            </p>
          </div>
          <div>
            <p>
              Has any license, permit or privilege to drive ever been suspended
              or revoked?
              <span className="inline-flex align-items-center gap-3 ml-4">
                <span
                  className={
                    !ownerOperatorData?.any_license_suspended ? "font-semibold" : ""
                  }
                >
                  No
                </span>
                <InputSwitch
                  checked={ownerOperatorData?.any_license_suspended}
                  onChange={(e) =>
                    setOwnerOperatorData((prev) => ({
                      ...prev,
                      any_license_suspended: !prev.any_license_suspended,
                    }))
                  }
                />
                <span
                  className={ownerOperatorData?.any_license_suspended ? "font-semibold" : ""}
                >
                  Yes
                </span>
              </span>
            </p>
          </div>
          <div>
            <p>
              Is there any reason that may prevent you from legally crossing the
              U.S. Border?{" "}
              <span className="inline-flex align-items-center gap-3 ml-4">
                <span
                  className={
                    !ownerOperatorData?.legal_crossing_us_banned ? "font-semibold" : ""
                  }
                >
                  No
                </span>
                <InputSwitch
                  checked={ownerOperatorData?.legal_crossing_us_banned}
                  onChange={(e) =>
                    setOwnerOperatorData((prev) => ({
                      ...prev,
                      legal_crossing_us_banned: !prev.legal_crossing_us_banned,
                    }))
                  }
                />
                <span
                  className={
                    ownerOperatorData?.legal_crossing_us_banned ? "font-semibold" : ""
                  }
                >
                  Yes
                </span>
              </span>
            </p>
          </div>
          <div>
            <p>
              Do yoou have fast card?
              <span className="inline-flex align-items-center gap-3 ml-4">
                <span className={ownerOperatorData?.fast_card === "No" ? "font-semibold" : ""}>
                  No
                </span>
                <InputSwitch
                  checked={ownerOperatorData?.fast_card !== "No"}
                  onChange={(e) =>
                    setOwnerOperatorData((prev) => ({
                      ...prev,
                      fast_card: e?.value
                        ? { card_number: "", expiry: "" }
                        : "No",
                    }))
                  }
                />
                <span className={ownerOperatorData?.fast_card !== "No" ? "font-semibold" : ""}>
                  Yes
                </span>
              </span>
            </p>
            {ownerOperatorData?.fast_card !== "No" &&
            <div className='flex flex-wrap'>
              <CustomInput
                label="Fast Card#"
                value={ownerOperatorData?.fast_card?.card_number}
                onChange={({ value }) =>
                  setOwnerOperatorData((prev) => ({
                    ...prev,
                    fast_card: { ...prev?.fast_card, card_number: value },
                  }))
                }
              />
              <CustomCalenderInput
                label="Fast Card#"
                value={ownerOperatorData?.fast_card?.expiry}
                onChange={({ value }) =>
                  setOwnerOperatorData((prev) => ({
                    ...prev,
                    fast_card: { ...prev?.fast_card, expiry: value },
                  }))
                }
              />
            </div>}
          </div>
        </div>
  )
}
